import templateUrl from "emun.salesrep/top-selling-productlines.htm";
import $appConfig from "servicestack/config";

export class TopSellingProductLinesController {
  constructor($window, $rootScope, createAutoQuery) {
    let $ctrl = this;
    $ctrl.productImage = $appConfig.productImage.bind($appConfig);

    var url = "QueryTopSellingProductLines.json?OrderBy=-YTD";
    if ($ctrl.customer) {
      url = url + "&CustomerId=" + $ctrl.customer.id;
    }
    if ($ctrl.rep) {
      url = url + "&RepId=" + $ctrl.rep.id;
    }

    this.topProductLines = createAutoQuery({
      url: url,
      autoLoad: true,
      pageSize: 10,
    });
  }
  downloadData() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      $ctrl.topProductLines.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }
}

export default {
  bindings: {
    rep: "<",
    customer: "<",
    context: "@",
    title: "@",
  },
  controller: TopSellingProductLinesController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
